import fetch from 'auth/FetchInterceptor'

const veiculoService = {}

veiculoService.all = function () {
  return fetch({
    url: '/veiculo/all',
    method: 'get',
    headers: {
        'Content-Type': 'application/json',
      },
  })
}

veiculoService.disponiveis = function () {
  return fetch({
    url: '/veiculo/disponivel',
    method: 'get',
    headers: {
        'Content-Type': 'application/json',
      },
  })
}

veiculoService.id = function (data) {
  return fetch({
    url: `/veiculo/${data}/id`,
    method: 'get',
    data: data
  })
}

veiculoService.paginated = function ({ page = 0, size = 10, placa = '' } = {}) {
  return fetch({
    url: '/veiculo',
    method: 'get',
    params: { page, size, placa },
  })
}

veiculoService.save = function (data) {
  return fetch({
    url: '/veiculo',
    method: 'post',
    data: data
  })
}

veiculoService.alterarRastreador = function (veiculoId, imei) {
  return fetch({
    url: `/veiculo/${veiculoId}/rastreador/${imei}/troca`,
    method: 'put'
  })
}

veiculoService.obterAcumuladores = function (id) {
  return fetch({
    url: `/veiculo/${id}/acumuladores`,
    method: 'get',
  })
}

veiculoService.ajustarAcumuladores = function (id, data) {
  return fetch({
    url: `/veiculo/${id}/acumuladores`,
    method: 'put',
    data: data,
  })
}

veiculoService.exportarCSV = function () {
  return fetch({
    url: '/veiculo/exportar-csv',
    method: 'get',
    responseType: 'blob',
  })
}

export default veiculoService